import Header from '../Components/Header.js'
import Main from '../Components/Main.js'
import Footer from '../Components/Footer.js'

function Home(){
  return(
    <>
    <Header page={1}/>
    <Main/>
    <Footer/>
    </>
  );
}

export default Home;